import {NotificationsPage} from "./experience/NotificationsPage";
import { Route, Routes } from "react-router-dom";
import { AccountsExperiencePage } from "./auth/AccountsExperiencePage";
import { useAccountsExperience } from "./auth/AccountsExperienceProvider";
import { HomePage } from "./home/HomePage";
import { NotFoundPage } from "./routes/NotFoundPage";
import { ServiceDetailPage, ClientRequestsPage, ClientRequestDetailPage, DeliverableDetailPage, DeliverablesPage, DecisionsPage, HelpArticlesPage, ProjectsServicesPage, ProjectDetailPage, DocumentsPage, ContractDetailPage, ProposalDetailPage, QuestionnairesPage, QuestionnaireDetailPage } from "./experience/ExperiencePages";
import { ApprovalsPage, ApprovalDetailPage } from "./experience/ApprovalExperiencePages";
import { AdsDashboardPage } from "./experience/AdsDashboardPage";
import { AgendaPage } from "./experience/AgendaPage";
import { DecisionDetailPage } from "./experience/CollaborationExperiencePages";
import { BillingInvoiceDetailPage, BillingPage } from "./experience/BillingExperiencePages";
import { SupportPage, SupportTicketDetailPage } from "./experience/SupportExperiencePages";
import { AppShell } from "./shell/AppShell";
import { useScenario } from "./scenario/ScenarioProvider";
import { useI18n } from "./i18n/I18nProvider";
import { EmptyState } from "../ui/NavePage";

import { ADS_DEMO_ENABLED } from "./shell/ads-demo";

/** Shown instead of the area pages until a client is picked, so no client-scoped request fires (and 403s) first. */
const ClientSelectionRequired = () => {
  const { t } = useI18n();
  return <div className="nave-page"><EmptyState icon="lucide:building-2">{t("client.selectionRequired")}</EmptyState></div>;
};

export const App = () => {
  const { state } = useAccountsExperience();
  const { session } = useScenario();
  const clientRequired = session !== undefined && !session.activeClient;

  if (state.kind !== "AUTHENTICATED") {
    return <AccountsExperiencePage state={state} />;
  }

  if (clientRequired) {
    return (
      <AppShell>
        <Routes>
          <Route path="/notifications" element={<NotificationsPage/>}/>
          <Route path="*" element={<ClientSelectionRequired />} />
        </Routes>
      </AppShell>
    );
  }

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {ADS_DEMO_ENABLED ? <Route path="/ads" element={<AdsDashboardPage/>}/> : null}
        <Route path="/agenda" element={<AgendaPage/>}/>
        <Route path="/requests" element={<ClientRequestsPage/>}/>
        <Route path="/requests/:requestId" element={<ClientRequestDetailPage/>}/>
        <Route path="/deliverables" element={<DeliverablesPage/>}/>
        <Route path="/deliverables/:deliverableId" element={<DeliverableDetailPage/>}/>
        <Route path="/services/:serviceId" element={<ServiceDetailPage/>}/>
        <Route path="/projects" element={<ProjectsServicesPage />} />
        <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/billing/invoices/:invoiceId" element={<BillingInvoiceDetailPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/help" element={<HelpArticlesPage/>}/>
        <Route path="/notifications" element={<NotificationsPage/>}/>
        <Route path="/support" element={<SupportPage />} />
        <Route path="/support/tickets/:ticketId" element={<SupportTicketDetailPage />} />
        <Route path="/documents/contracts/:contractId" element={<ContractDetailPage />} />
        <Route path="/documents/proposals/:proposalId" element={<ProposalDetailPage />} />
        <Route path="/questionnaires" element={<QuestionnairesPage />} />
        <Route path="/questionnaires/:questionnaireId" element={<QuestionnaireDetailPage />} />
        <Route path="/approvals" element={<ApprovalsPage />} />
        <Route path="/approvals/:approvalId" element={<ApprovalDetailPage />} />
        <Route path="/decisions" element={<DecisionsPage/>} />
        <Route path="/decisions/:decisionId" element={<DecisionDetailPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AppShell>
  );
};
